module.exports = __webpack_public_path__ + "./img/48037a251de468425d6f5b080825f2e6.png";